import _sfc_main from "./Checkbox.vue2.js";
/* empty css              */
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const Checkbox = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-ad35b8d8"]]);
export {
  Checkbox as default
};
//# sourceMappingURL=Checkbox.vue.js.map
